import React from 'react'
import { useLocale } from '@/utils/LocaleUtil'
import { useTranslate } from '@/utils/translate/translate-client'

interface WatchingNowMessageProps {
  totalViewers: number
}

export const WatchingNowMessage: React.FC<WatchingNowMessageProps> = ({ totalViewers }) => {
  const { t } = useTranslate('livestream')
  const { locale } = useLocale()
  const compactFormatter = Intl.NumberFormat(locale, { notation: 'compact', compactDisplay: 'short' })

  return (
    <span>
      {t('totalViewersCount', {
        count: totalViewers,
        defaultValue_one: '{{totalViewers}} watching now',
        defaultValue_other: '{{totalViewers}} watching now',
        totalViewers: compactFormatter.format(totalViewers),
      })}
    </span>
  )
}
